import React from 'react';
import tabletImage from '../../components/LandingPage/images/tabImg.png';  // Update with your tablet image path

const StepTwo = () => {
    return (
        <div>
            <div className="flex flex-col lg:flex-row-reverse justify-between items-center w-full py-12 px-2">
                {/* Right Section: Text */}
                <div className="lg:w-[30%]  text-center sm:text-right mb-8 lg:mb-0">
                    <h1 className="text-3xl md:text-4xl font-raleway font-extrabold text-black">
                        Explore the World Through <span className="text-[#A67FAA] font-raleway">Cooking</span>
                    </h1>
                    <p className="text-xl md:text-2xl font-publicSans mt-10  font-semibold text-black">
                        Immerse yourself in the rich narratives and traditions behind every meal as you create authentic dishes from global cultures.                    </p>
                </div>

                {/* Left Section: Tablet Image */}
                <div className="lg:w-[70%] flex justify-start">
                    <img src={tabletImage} alt="Tablet" className="w-full max-w-2xl" />
                </div>
            </div>
        </div>
    );
};

export default StepTwo;
